module.exports = __webpack_public_path__ + "assets/login-background.jpg?86d9ad6f0f46158adbf9543b8c68c2d9";